import type { FilterPanelFooterProps } from "./types-footer";
import { useFilterPanelFooter } from "./use-footer";
import { FilterPanelFooterView } from "./view-footer";

export function FilterPanelFooter(props: FilterPanelFooterProps) {
  const viewModel = useFilterPanelFooter(props);

  return <FilterPanelFooterView {...viewModel} />;
}
FilterPanelFooter.displayName = "FilterPanel.Footer";
